import { render, staticRenderFns } from "./IndexTag.vue?vue&type=template&id=e292f976&scoped=true"
import script from "./IndexTag.vue?vue&type=script&lang=js"
export * from "./IndexTag.vue?vue&type=script&lang=js"
import style0 from "./IndexTag.vue?vue&type=style&index=0&id=e292f976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e292f976",
  null
  
)

export default component.exports